import React, { Component } from 'react';
import OfferData from './OfferData';
import PersonData from './PersonData';
import PatientData from './PatientData';
import AddressData from './AddressData';
import UsualDonation from './UsualDonation';
import Toolbar from '../../toolbar';
import moment from 'moment';
import AvatarPerson from './AvatarPerson';
import Notifications, {notify} from 'react-notify-toast';
import swal from 'sweetalert';
import Parser from 'html-react-parser';
import isEmail from 'validator/lib/isEmail';

const {htmlToText} = require('html-to-text');

var Config = require('../../../config');
const $ = require('jquery');

class FormOffers extends Component{
	constructor(props, context) {

		super(props, context);
		this.getOffer = this.getOffer.bind(this);
		this.setInfoDonor = this.setInfoDonor.bind(this);
		this.setInfoPatient = this.setInfoPatient.bind(this);
		this.clearSearch = this.clearSearch.bind(this);
		this.clearPatientSearch = this.clearPatientSearch.bind(this);
		this.setOfferId = this.setOfferId.bind(this);

		this.getInfo = this.getInfo.bind(this);

		this.specialFields = this.specialFields.bind(this);
		this.getAnswers = this.getAnswers.bind(this);
		this.setAnswers = this.setAnswers.bind(this);
		this.datePatHandleChange = this.datePatHandleChange.bind(this);
		this.calcularEdadPat = this.calcularEdadPat.bind(this);

	    //Definicion de variables
	    this.state = { 
	    	option:"",
	    	patient_id:'',
	    	donation_type_id:'',
	    	day_sesion_donation:'',
	    	timestamp:'',//
	    	timestamp_date:'',
	    	timestamp_hour:'',
	    	convoke_places_id:"",//
	    	donation_type_extraction_id:'',//
	    	donor_number:'',//
	    	aux_donor_number:'',
	    	patient:'',//
			patient_name:'',//
			patient_birthday:"",
	    	patient_lastname1:'',//
	    	patient_lastname2:'',//
	    	health_facility_id:'',//
	    	facility_section_id:'',//
	    	photo:"",//
	    	relationship:"",
	    	lookup_group:"",
	    	lookup_rh:"",
	    	rh_group:"",
	    	observations:"",
	    	national_name:"",
	    	national_center_id:"",
	    	no_file:"",
	    	patient_person_id:"",

	    	document_type:"DOCUMENT_INE",
	    	document_number:"",
	    	names: "",
	    	lastname1:"",
	    	lastname2:"",
	    	civil_status:"",
	    	birthday:"",
	    	age:"",
			sex:"",
			social_number:"",

			street:"",
			postal_code:"",
			mpio:"",
			state:"",

			phonesAdded:[],

			scholarship:"",
			job_profile:"",

			convokes:[],
			placesAdded:[],
			letter:false,
			phone:false,
			cel_phone:false,
			sms:false,
			email:"",
			finger_image:"",
			fmd:"",
			donor_id:"",
			person_donor_id:"",
			address_id:"",
			person_patient_id:"",
			stats:{
				last_donation_date:"",
				donation_type:"",
				extraction_type:"",
				total_donations:0,
				total_last_year:0,
				lookup_group:"",
				lookup_rh:"",
				lectina:"",
				status_bar_color:"",
				temporality:"",
				reject_process:"",
				total_offers:0,
			},
			show_patient_data:false,
			don_hue_dig:{},
			blockFields:false,
			blockFieldsPatient:false,
			checkEditData:false,
			checkEditDataPatient:false,
			recurrent:false,
			recurrent_center_id:"",

			disableOnView:false,
			offer_id:"",
			special_donor:[],
			special_patient:[],
			special_values:[],

			required_fields:[],

			campaigns:[],
			campaign_id:"",
			show_campaigns:false,
			patient_sex:"",
			emergency_level:"",
			flag_notes:false,
			hc_status:"",
			error_email:"",
			patient_number:"",
			can_edit:true,
	    }
	}

	//Consulta de servicios necesarios para la pantalla
	componentDidMount() {
		
		$(document).on('blur', '.input-date', (e)=>{
			var date = moment(e.target.value, 'DD/MM/YYYY').format('YYYY-MM-DD');
			
			if(e.target.value !== ""){
				if(date === 'Invalid date' || date === 'Fecha inválida'){
					swal('Error', 'Debes ingresar un valor válido. El campo está incompleto o contiene una fecha no válida.', 'error');

					$('#'+e.target.id).addClass('error');

					setTimeout(()=>{
						$('#'+e.target.id).val('');
						e.target.value = "";
						
						this.dateHandleChange(e);
					}, 3500)
				}else{
					$('#'+e.target.id).removeClass('error');
				}
			}else{
				$('#'+e.target.id).removeClass('error');
			}
		});
		
		$(document).on('keyup', '.form-control', function(){
			if($(this).val() !== ""){
				if($(this).hasClass('error')){
					$(this).removeClass('error');
				}
			}
		});

		

		this.props.onRef(this)

		var newelement = {};
		var convoke_places_id = "";

		newelement.code = "";
		newelement.errorText_code = "";

		if(sessionStorage.getItem("convoke_places_id") !== null){
			convoke_places_id = parseInt(sessionStorage.getItem("convoke_places_id"),10);
		}

		fetch(Config.default.apiGateway.URL+'campaigns/current',{
			method:'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({campaigns:response});
			}
		});

		this.specialFields(1, 0);

		this.setState({ 
		  convokes: this.state.convokes.concat([newelement]),
		  convoke_places_id:convoke_places_id
		})

		fetch(Config.default.apiGateway.URL+'offers?option=next_id',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			//this.setState({donor_number:response,aux_donor_number:response});
		})

		//Consultar el turno correspondiente y mostrarlo
		fetch(Config.default.apiGateway.URL+'work_sessions/?option=&health_facilities_id='+sessionStorage.getItem("health_facilities_id"),{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			if(response !== null){
				this.setState({day_sesion_donation:response.id});
			}else{
				swal('¡Atención!', "No existen sesiones de trabajo configuradas para su hospital", 'warning');
			}
		})

		//Criterio funcional,cambiar lugar de colecta
		fetch(Config.default.apiGateway.URL+'functional_criterion?code=don_hue_dig',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
		      don_hue_dig: response
		    });
		})

		if(this.props.agenda){
			this.setState({
				timestamp_date: this.props.match.params.date,
				timestamp_hour: this.props.match.params.hour
			});
		}
	}

	componentWillUnmount() {
		this.props.onRef(null)
	}
	validString(value, name){
		if(name === 'patient_name' || name === 'patient_lastname1' || name === 'patient_lastname2'){
			return new RegExp("^[a-zA-Záéíóú´ ()ñÑ]+$").test(value);
		}else{
			return new RegExp("^[a-zA-Záéíóú´ ./ñÑ]+$").test(value);
		}
	}

	//Evento de cambio en elementos formulario
	handleChange = (event, index, value) => {
		if(event.target.name === 'names' || event.target.name === 'lastname1' || event.target.name === 'lastname2' ||
		event.target.name === 'patient_name' || event.target.name === 'patient_lastname1' || event.target.name === 'patient_lastname2'){
			var ok = true;
			if(event.target.value === ""){
				this.setState({
			      [event.target.name]: event.target.value
			    });		
			}
			if(this.validString(event.target.value, event.target.name)){
				if(event.target.name === 'names'){
					if(event.target.value .length > 100){
						ok = false;
					}
				}

				if(event.target.name === 'lastname1' || event.target.name === 'lastname2'){
					if(event.target.value .length > 50){
						ok = false;
					}
				}

				if(ok){
					this.setState({
						[event.target.name]: event.target.value
					});		
				}
				
			}
		}else if(event.target.name === 'postal_code'){
			if(event.target.value === ""){
				this.setState({[event.target.name]: event.target.value})
			}
			if(event.target.value.length < 6){
				let regex = new RegExp("^[0-9]+$");

				if(regex.test(event.target.value)){
					this.setState({[event.target.name]: event.target.value})
				}
				
			}
		}else if(event.target.name === 'email'){
			this.setState({[event.target.name]: event.target.value});

			if(!isEmail(event.target.value)){
				this.setState({error_email: event.target.value !== "" ? 'Formato no valido' : ""});
			}else{
				this.setState({error_email: ''});
			}
			
		}else{
			this.setState({
		      [event.target.name]: event.target.value
		    });
		}
		    

	    if(event.target.name === 'campaign_id'){
	    	var convokes = this.offer.state.convoke_places;

	    	if(event.target.value !== ""){
	    		var id = parseInt(event.target.value);
		    	var index = this.state.campaigns.findIndex(obj =>
		    		obj.id === id
		    	)

		    	if(index !== -1){
		    		convokes.push(this.state.campaigns[index]);

		    		this.offer.setState({
			    		convoke_places: convokes
			    	});
			    	this.setState({
			    		convoke_places_id: this.state.campaigns[index].convoke_places_id
			    	});

			    	document.getElementById('convoke_places_id').disabled = true;
		    	}
		    	
	    	}else{

	    		convokes.splice(convokes.length - 1, 1);
	    		
	    		this.offer.setState({
		    		convoke_places: convokes
		    	});
		    	this.setState({
		    		convoke_places_id: ""
		    	});

		    	document.getElementById('convoke_places_id').disabled = false;

	    	}
	    }else if(event.target.name === 'timestamp_hour' && this.props.agenda){
	    	var hour = moment(event.target.value, 'h:mm a');

			if(hour.format('H:mm') === "Invalid date" || event.target.value.indexOf('-') !== -1){
				document.getElementById(event.target.id).classList.add("error");
				document.getElementById(event.target.name).style.borderColor = "red";
			}else{
				document.getElementById(event.target.name).style.borderColor = "#ccc";
				document.getElementById(event.target.id).classList.remove("error");
			}
	    }

	    if(event.target.id !== null){
	        var control = document.getElementById(event.target.id);
	        if(control !== null){
	          if(control.className.includes('error')){
	            control.classList.remove('error');
	          }else if(control.required && event.target.value===""){
	            control.classList.add('error');
	          }
	        }
	    }
	}

	selectFieldHandle = (id, name, event, index, value) => {
		this.setState({[event.target.name]:event.target.value});

		if(event.target.name === "donation_type_id"){
			if(this.state.patient_person_id === ""){
				if(this.patient !== undefined && this.patient !== null){
					
					setTimeout(()=>{
						if(this.patient!== null){
							this.patient.refs._handleSearch._instance.clear();	
						}
						
					}, 500);
					
				}
				this.clearPatientSearch();
			}
		}

		if(event.target.id !== null){
	        var control = document.getElementById(event.target.id);
	        if(control !== null){
	        	if(control.required){
	        		if(event.target.value!==""){
	        			if(control.className.includes('error')){
	        				 control.classList.remove('error');
	        			}
	        		}
	        	}else{
	        		if(event.target.value!==""){
	        			if(control.className.includes('error')){
	        				 control.classList.remove('error');
	        			}
	        		}
	        	}
	        }
	    }
	}

	autocompleteHandle = (name,value) => {
		this.setState({[name]:value});
	}

	dateHandleChange = (event) => {

		if(event.target.id === "birthday"){
			this.setState({ birthday: event.target.value});
			
			var control = document.getElementById(event.target.id);
			if(event.target.value.length === 10){
				control.classList.remove('error');
				this.calcularEdad(event.target.value,control);
			}else{
				control.classList.add('error');
			}
		}else{
			this.setState({ patient_birthday: event.target.value});
		}
	}

	clearSearch(){
		this.setState({blockFields:false,names:"",lastname1:"",lastname2:"",sex:"",civil_status:"",scholarship:"",
				job_profile:"",birthday:"",street:"",postal_code:"",mpio:"",state:"",person_donor_id:"",
				address_id:"",donor_id:"",donor_number:this.state.aux_donor_number,fmd:"",age:"",document_type:"",document_number:""
				,checkEditData:false,photo:"",finger_image:"",phonesAdded:[],email:"",
				//recurrent:false,
				//recurrent_center_id:"",
				stats:{
					last_donation_date:"",
					donation_type:"",
					extraction_type:"",
					total_donations:0,
					total_last_year:0,
					total_offers:0,
					lookup_group:"",
					lookup_rh:"",
					lectina:"",
					temporality:"",
					total_hc:0,
					reject_process:"",
					error_email:""
				}});
		this.address.clearSearch();
		this.person_data.clearSearch();
		this.clearAnswers();
	}

	clearPatientSearch(){
		this.setState({
			patient_lastname1:"",
			patient_lastname2:"",
			patient_name:"",
			lookup_group:"",
			lookup_rh:"",
			person_patient_id:"",
			patient_person_id:"",
			observations:"",
			relationship:"",
			facility_section_id:"",
			national_center_id:"",
			national_name:"",
			no_file:"",
			patient_birthday:"",
			person_patient_id:"",
			patient_id:"",
			patient_sex:"",
			rh_group:"",
			//patient_number:""
		});
		//this.props.getPatientNumber();

		if(this.patient !== undefined && this.patient !== null){
			this.patient.setState({disablePatient:false});
		}
	}

	//desplegar errores en selceted
	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);

		if(refName !== 'phone_number'){
			if(this.state[refName] === undefined){
				if(control !== null){
					if(control.required){
						if(control.value === ""){
							control.classList.add('error');
				        	res = false;
				        	
						}else{
							if(control.className.includes('error')){
								control.classList.remove('error');
				        		
							}
							res = true;
						}

					}
			    }
				
			}else{
				if(control.value === ""){
					control.classList.add('error');
					res = false;

					return res;
				}else{
					if(control.required && control.className.includes('error')){
						control.classList.remove('error');
					}

					res = true;
				} 
			}

				
		}else{
			res = true;
		}	

		return res;
		
	}

	//Evento para checkbox
	handleCheck = event => {
	    this.setState({
	      [event.target.name]: event.target.checked
	    });

	    if(!event.target.checked && this.state.campaign_id !== ""){
	    	var convokes = this.offer.state.convoke_places;
			convokes.splice(convokes.length - 1, 1);
	    		
    		this.offer.setState({
	    		convoke_places: convokes
	    	});
	    	this.setState({
	    		convoke_places_id: "",
	    		campaign_id:""
	    	});

	    	document.getElementById('convoke_places_id').disabled = false;
	    }
	}

	//calcular edad
	calcularEdad(fecha,control){
		var hoy = new Date();
	    var cumpleanos = new Date(fecha.split(/\//).reverse().join('/'));
	    if(cumpleanos.toString() !== 'Invalid Date'){
		    var edad = hoy.getFullYear() - cumpleanos.getFullYear();
		    var m = hoy.getMonth() - cumpleanos.getMonth();

		    if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
		        edad--;
		    }
		    if(edad >= 0 && edad < 110){
		    	this.setState({age:edad});	
		    }else{
		    	this.setState({age:'', birthday:''});	
		    	swal('Error', 'Fecha de nacimiento incorrecta', 'error');
		    }
		}else{
			/*control.classList.add('error');
			notify.show('Error, Fecha no válida','error');*/
		}
	}

	//agregar telefono
	addPhoneToList = (phone) => {
		
		this.setState({ phonesAdded: [...this.state.phonesAdded, phone]});
	}

	removePhoneFromList = (indice) => {
		if(!this.state.disableOnView){
			var array = [...this.state.phonesAdded];
			array.splice(indice, 1);
			this.setState({phonesAdded: array});
		}
	}

	//agregar lugar
	addPlaceToList = (place) => {
		this.setState({ placesAdded: [...this.state.placesAdded, place]})
	}

	//borrar lugar de listado
	removePlaceFromList = (indice) => {
		var array = [...this.state.placesAdded];
		array.splice(indice, 1);
		this.setState({placesAdded: array});
	}

	updatePhoto=(photo)=>{
		this.setState({photo:photo});
	}

	updateFingerprint=(image, fmd)=>{
		this.setState({finger_image:image,fmd:fmd});
	}

	getOffer(){
		var offer = {};
		var date = this.state.timestamp_date !== "" ? moment(this.state.timestamp_date).format('YYYY-MM-DD') : "";
		var hour = this.state.timestamp_hour !== "" ? moment(this.state.timestamp_hour, 'h:mm a').format('H:mm') : "";
		offer.timestamp_date = date;
		offer.timestamp_hour = hour;
		offer.convoke_places_id = this.state.convoke_places_id;
		offer.work_session_id = this.state.day_sesion_donation;
		offer.donation_type_extraction_id = this.state.donation_type_extraction_id;
		offer.donation_type_id = this.state.donation_type_id;
		offer.donor_age = parseInt(this.state.age,10);
		offer.health_facilities_id = sessionStorage.getItem('health_facilities_id');
		offer.patient_relationship = this.state.relationship;
		offer.patient_section_name = this.state.national_name;
		offer.national_center_id = this.state.national_center_id;
		offer.emergency_level = this.state.emergency_level;
		offer.recurrent = this.state.recurrent;
		offer.recurrent_center_id = this.state.recurrent_center_id

		if(this.props.show_promotion){
			offer.campaign_id = this.state.campaign_id;
		}

		if(this.props.match.params.preoffer_id !== undefined){
			offer.pre_offers_id = this.state.pre_offers_id;
		}


		if(this.state.age === ""){
			var hoy = new Date();
			var cumpleanos = new Date(this.state.birthday.split(/\//).reverse().join('/'));
			if(cumpleanos.toString() !== 'Invalid Date'){
				var edad = hoy.getFullYear() - cumpleanos.getFullYear();
				var m = hoy.getMonth() - cumpleanos.getMonth();

				if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
					edad--;
				}
				if(edad >= 0 && edad < 110){
					offer.donor_age = edad;
				}
			}
		}

		return offer;
	}

	getDonor(){
		var donor = {};

		donor.donor_number = parseInt(this.state.donor_number,10);
		if(this.state.donor_id !== ""){
			donor.id = this.state.donor_id;
		}

		return donor;
	}

	getFingerprint(){
		return this.state.fmd;
	}

	getFingerprintImg(){
		var aux = this.state.finger_image.split(',');
		return aux[1];
	}

	getPerson(){
		var person = {};

		person.lastname1 = this.state.lastname1;
		person.lastname2 = this.state.lastname2;
		person.names = this.state.names;
		person.birthday = this.state.birthday.split(/\//).reverse().join('/');
		person.sex = this.state.sex;
		person.civil_status = this.state.civil_status;
		person.person_type='donor';
		person.phones = this.state.phonesAdded;
		person.scholarship = this.state.scholarship;
		person.job_profile = this.state.job_profile;
		person.email = this.state.error_email !== "" ? "" : this.state.email;
		person.documents = [];
		
		if(this.state.document_type !== ""){
			var obj = {}
			obj.document_type = this.state.document_type;
			obj.document_number = this.state.document_number;
			if(this.props.agenda){
				if(this.state.person_donor_id !== ""){
					obj.person_id = this.state.person_donor_id;
				}
			}

			if(obj.document_number !== null && obj.document_number !==undefined && obj.document_number !== "")
				person.documents.push(obj);
		}

		if(this.state.person_donor_id !== ""){
			person.id = this.state.person_donor_id;
		}

		if(this.state.stats !== ""){
			person.lookup_group = this.state.stats.lookup_group;
			person.lookup_rh = this.state.stats.lookup_rh;
		}

		return person;
	}

	getPersonPatient(){
		var person = {}

		person.lastname1 = this.state.patient_lastname1;
		person.lastname2 = this.state.patient_lastname2;
		person.names = this.state.patient_name;
		person.person_type='patient';
		person.lookup_group = this.state.lookup_group;
		person.lookup_rh = this.state.lookup_rh;
		person.social_number = this.state.social_number;
		person.sex = this.state.patient_sex;
		person.birthday = this.state.patient_birthday!= "" ?
							this.state.patient_birthday.split(/\//).reverse().join('/')
						:"";
		if (this.state.person_patient_id !== "") {
			person.id = this.state.person_patient_id;
		};

		if(!this.props.agenda){
			person.patient = [];
			var patient_aux = {};
			patient_aux.observations = this.state.observations;
			patient_aux.number = this.state.no_file;
			patient_aux.patient_number = this.state.patient_number;

			if (this.state.patient_id !== "") {
				patient_aux.id = this.state.patient_id;
				patient_aux.person_id = person.id;
			};

			person.patient.push(patient_aux);
		}
		
		return person;
	}

	getAddress(){
		var address = {};

		address.street = this.state.street;
		address.postal_code = this.state.postal_code;
		address.municipio = this.state.mpio;

		address.estado = this.state.state;
		if(this.state.address_id!==""){
			address.id = this.state.address_id;
		}

		return address;
	}

	getPhoto(){
		var aux = this.state.photo.split(',');
		return aux[1];
	}

	setInfoDonor(item){
		if(item !== "" && item !== null && item!== undefined){
			if(item.person.photo !== null && item.person.photo !==undefined){
				this.setState({photo:'data:image/jpeg;base64,'+item.person.photo});
			}else{
				this.setState({photo:""});
			}
			if(item.donor.fingerprint_img !== null){
				this.setState({finger_image:'data:image/jpeg;base64,'+item.donor.fingerprint_img});
			}else{
				this.setState({finger_image:""});
			}
			var aux_date = new Date(item.person.birthday);
			var string_date = ("0" + aux_date.getDate()).slice(-2)+'/'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'/'+aux_date.getFullYear();

			this.setState({
				names:item.person.names,
				lastname1:item.person.lastname1,
				lastname2:item.person.lastname2!==null?item.person.lastname2:"",
				sex:item.person.sex,
				civil_status:item.person.civil_status,
				scholarship:item.person.scholarship,
				job_profile:item.person.job_profile,
				email:item.person.email,
				birthday:string_date,
				street: item.address !== null? item.address.street:null,
				postal_code: item.address !== null? item.address.postal_code:null,
				mpio: item.address !== null? item.address.municipio:null,
				state: item.address !== null? item.address.estado:null,
				person_donor_id:item.person.id,
				address_id: item.address !== null? item.address.id:null,
				donor_id:item.donor.id,
				donor_number:item.donor.donor_number,
				fmd:item.donor.fingerprint,
				
				
			});

			if(this.state.donor_id !== 0 && this.state.donor_id !== ""){
				this.setState({
					stats:{
						date_label:item.offer.date_label,
						last_donation_date:item.offer.date,
						donation_type:item.offer.donation_type,
						extraction_type:item.offer.extraction_type,
						total_donations:item.total_donations,
						total_last_year:item.total_month,
						total_offers:item.total_offers,
						lookup_group:item.person.lookup_group,
						lookup_rh:item.person.lookup_rh,
						group_test:item.offer.group_test,
						status_bar_color:item.status_bar_color,
						temporality:item.temporality,
						total_hc:item.total_hc,
						reject_process:item.reject_process,
						lectina:item.person !== null ? item.person.lookup_lectin !== null ? item.person.lookup_lectin: "" : ""
					}
				})
			}

			if(item.document.document !== null && item.document.document !== undefined){
				this.setState({
					document_type:item.document.document.document_type,
					document_number:item.document.document.document_number
				});
			}
			this.calcularEdad(string_date,'birthday');
			if(item.address !== null){
				this.address.getMpios(item.address.estado,item.address.municipio);
			}

			this.setState({phonesAdded:[]});

			this.person_data.setJobProfile(item.person.job_profile);

			
			if(item.phones !== undefined){
				var phones = [];

				for(var i = 0; i < item.phones.length; i++){
					var aux_phone = {};
					aux_phone.type = item.phones[i].type;
					aux_phone.number = item.phones[i].number;
					aux_phone.extension = item.phones[i].extension;

					phones.push(aux_phone);
					
				}

				this.setState({
					phonesAdded: phones
				})
			}
		
			if(item.alerts !== undefined){
				if(item.alerts.length > 0){
					var alerts = "";
					item.alerts.map((n)=>{
						var note = htmlToText(n);
						alerts += note;
					})

					swal('Alerta', alerts, 'warning')
				}
			}
				
		}else{
			//this.setState({stats:{}});
		}
	}

	setInfoPatient(item){
		if(item !== "" && item !== undefined)
		{
			var aux_date = new Date(item.person.birthday);
			var string_date = ("0" + aux_date.getDate()).slice(-2)+'/'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'/'+aux_date.getFullYear();

			this.setState({
				patient_name:item.person.names,
				patient_lastname1:item.person.lastname1,
				patient_lastname2:item.person.lastname2,
				patient_id:item.patient.id,
				person_patient_id:item.person.id,
				social_number:item.person.social_number,
				patient_sex: item.person.sex,
				patient_birthday:item.person.birthday !== null ? string_date : "",
				patient_number:item.patient.patient_number === null ? "" : item.patient.patient_number
			});

			if(item.patient.patient_number === null && item.patient.patient_number === ""){			
				this.props.getPatientNumber();
			}


			//if (item.patient.observations) {
				this.setState({observations:item.patient.observations});
			//};


			//if (item.patient.number) {
				this.setState({no_file:item.patient.number});
			//};

			if (item.person.lookup_group !== "" && item.person.lookup_rh !== "") {

				this.setState({
					lookup_group:item.person.lookup_group,
				    lookup_rh:item.person.lookup_rh,
					rh_group: item.person.lookup_group + (
						item.person.lookup_rh === 'POSITIVO' ? ' +' :
						item.person.lookup_rh === 'NEGATIVO' ? ' -' : ''
					),
				
				});

			}else{
				this.setState({
					rh_group: "",
				});
			}

			if(this.state.national_center_id !== ""){
				//this.patient.getNationalCenters();

				this.patient.setNationalCenter(this.state.national_center_id);
			}

			this.props.waiting.handleClose();
			//this.patient.setState({disablePatient:true});
		}
	}

	//get offer_id
	setOfferId(offer_id, donor_id, donor_number){
		this.setState({donor_number:donor_number, offer_id:offer_id});
		this.tool.enableOptions(offer_id, donor_id);
	}
	
	getInfo(id){
		if(id !== "" && id!== undefined){
			return fetch(Config.default.apiGateway.URL+'donors?option=loadDonor&donor_id='+id,{ 
				method: 'get',
				headers: new Headers({
				   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				   'Accept': 'application/json',
					'Content-Type': 'application/json',
				})
			})
			.then(response => response.json())
			.then((response) => {
				if(response !== "" && response !== null){
					this.props.waiting.handleClose();

					this.setInfoDonor(response);
				}
			})
		}
	}

	validateInput(e) {
	    const re = /^[-+]?$/;
	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);
      		if(form.elements[index + 1] !== undefined){

      			if(form.elements[index + 1].getAttribute("disabled") !== undefined){
    				if(form.elements[index + 1].getAttribute("disabled") === null)
    					form.elements[index + 1].focus();
    			
    				else if(form.elements[index + 1].getAttribute("disabled") === "")
    					form.elements[index + 2].focus();
    			}
      		}
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
  	}

  	specialFields(donor, patient){
  		
  		fetch(Config.default.apiGateway.URL+'Campos/special?health_facilities_id='+
  			sessionStorage.getItem('health_facilities_id')+'&for_donors='+donor+'&for_patients='+patient,{
  			method:'get',
  			headers: new Headers({
  				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
  				'Accept'		: 'application/json',
  				'Content-Type'	: 'application/json'
  			})
  		}).then(res => {
  			if(res.ok){
  				return res.json();
  			}else{
  				res.text().then((msg)=>{
  					swal('Error', msg, 'error');
  				});
  			}
  		}).then(response => {
  			if(response !== undefined){
  				if(patient === 1){
  					this.setState({
  						special_patient: response
  					});
  				}else{
  					this.setState({
  						special_donor: response
  					});
  				}
  			}
  		});
  	}

  	clearAnswers(){
  		this.state.special_donor.map((s)=>{
			document.getElementById(s.IdCampo).value = ''
		});

		/*if(this.state.show_patient_data){
			this.state.special_patient.map((s)=>{
				document.getElementById(s.IdCampo).value = ''
			})
		}*/
  	}

  	getAnswers(){
		var obj = {}, res =[];

		this.state.special_donor.map((s)=>{

			obj = {
				campos_id:s.IdCampo,
				valor:document.getElementById(s.IdCampo).value
			};

			var index = this.state.special_values.indexOf(obj => 
				obj.campos_id === s.IdCampo
			);

			if(index !== -1){
				obj.id = this.state.special_values[index].id;
				obj.offer_id = this.state.special_values[index].offer_id;

				//if(obj.valor !== ""){
					res.push(obj);
				//}
			}else{
				//if(obj.valor !== ""){
					res.push(obj);
				//}
			}

		});

		/*if(this.state.show_patient_data){
			this.state.special_patient.map((s)=>{
				obj = {
					campos_id:s.IdCampo,
					valor:document.getElementById(s.IdCampo).value
				}

				var index = this.state.special_values.indexOf(obj => 
					obj.campos_id === s.IdCampo
				);

				if(index !== -1){
					obj.id = this.state.special_values[index].id;
					obj.offer_id = this.state.special_values[index].offer_id;

					//if(obj.valor !== ""){
						res.push(obj);
					//}
				}else{
					//if(obj.valor !== ""){
						res.push(obj);
					//}
				}
			})
		}*/
		
		return res;
	}

	setAnswers(items){
		items.map((item)=>{
			document.getElementById(item.campos_id).value = item.valor;
		});
	}

	datePatHandleChange = (event) => {
		this.setState({
	      patient_birthday: event.target.value
	    });
		
		var control = document.getElementById(event.target.id);

		if(event.target.value.length === 10 && event.target.value.indexOf('_') === -1 ){
			control.classList.remove('error');
	    	this.calcularEdadPat(event.target.value, control);
		}else{
			if(event.target.value === ""){
				control.classList.remove('error');
			}else{
				control.classList.add('error');
			}
			
		}
	}

	//calcular edad
	calcularEdadPat(fecha,control){
		var hoy = new Date();
	    var cumpleanos = new Date(fecha.split(/\//).reverse().join('/'));
	    if(cumpleanos.toString() !== 'Invalid Date'){
		    var edad = hoy.getFullYear() - cumpleanos.getFullYear();
		    var m = hoy.getMonth() - cumpleanos.getMonth();

		    if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
		        edad--;
		    }
		    
		    if(edad >= 0 && edad < 110){	
		    }else{
		    	this.setState({[control.id]:''});	
		    	swal('Error', 'Fecha de nacimiento incorrecta', 'error');
		    }

		}
	}

	//Contenido del Formulario
	render(){
		return(
			<div className="col-xs-12" style={{padding:'0px'}}>
				<div className="col-xs-9">
					{!this.props.agenda ?
						this.state.campaigns.length > 0  && this.props.show_promotion?
						<div className="col-xs-12" style={{padding:'0px'}}>
							<div className="col-xs-12 col-sm-4">
								<span className="span-min">Campaña</span>
								<select className="form-control" value={ this.state.campaign_id || "" } 
						        	onChange={ this.handleChange } name="campaign_id" id="campaign_id">
					              	<option value="">Seleccionar...</option>
					                {this.state.campaigns.map((t, i) =>(
					                	<option key={i} value={t.id}>
					                		{t.name}
					                	</option>
					                ))}
				              	</select>
							</div>
														
						</div>
						:null
					:null}
					
					<OfferData setState={this.setState} 
						validate={this.validateInput}
						state={this.state} 
						onRef={ref => (this.offer = ref)}
						handleChange={this.handleChange} 
						selectFieldHandle={this.selectFieldHandle} 
						returnPhoto={this.updatePhoto} 
						returnFingerprint={this.updateFingerprint}
						setInfoDonor={this.setInfoDonor}
						getInfo={this.getInfo}
						finger_image={this.state.finger_image}
						autocompleteHandle={this.autocompleteHandle}
						clearSearch={this.clearSearch}
						clearPatientSearch = {this.clearPatientSearch}
						don_hue_dig={this.state.don_hue_dig}
						specialFields={this.specialFields}
						agenda={this.props.agenda}
						waiting={this.props.waiting}
						socket={this.props.socket}
					/>
					<PersonData {...this.props} 
						validate={this.validateInput}
						onRef={ref => (this.person_data = ref)} 
						state={this.state} 
						handleChange={this.handleChange} 
						selectFieldHandle={this.selectFieldHandle} 
						dateHandleChange={this.dateHandleChange}
						setInfoDonor={this.setInfoDonor}
						don_hue_dig={this.state.don_hue_dig}
						handleCheck = {this.handleCheck}
						autocompleteHandle={this.autocompleteHandle}/>
					<div className="col-xs-12" style={{padding:'0'}}>
					{!this.props.agenda ?
						this.state.special_donor.map((d, i)=>(
							<div key={i} className="col-xs-12 col-sm-2">
								<div><span className="span-min">{d.Etiqueta}</span></div>
								<div className="col-xs-12" style={{padding:'0'}}>
									{Parser(d.html)}
								</div>
							</div>
						))
					:null}
					</div>
					<AddressData 
						state={this.state} 
						validate={this.validateInput}
						handleChange={this.handleChange} 
						selectFieldHandle={this.selectFieldHandle} 
						autocompleteHandle={this.autocompleteHandle}
						onRef={ref => (this.address = ref)}/>
					{!this.props.agenda ? 
						<UsualDonation 
			        		validate={this.validateInput}
			        		state={this.state} 
			        		handleCheck = {this.handleCheck}
			        		handleChange={this.handleChange} 
			        		selectFieldHandle={this.selectFieldHandle} 
			        		addPlaceToList={this.addPlaceToList} 
			        		removePlaceFromList={this.removePlaceFromList}/>
					:null}
					
		        	{this.state.show_patient_data?
						<PatientData setState={this.setState} 
							location={this.props.location}
							requiredPatientCenter={this.props.match.path.indexOf('offers/new') !== -1 ? 
													true : false}
							waiting={this.props.waiting}
	        				validate={this.validateInput}
							state={this.state} 
							onRef={ref => (this.patient = ref)}
							handleChange={this.handleChange} 
							selectFieldHandle={this.selectFieldHandle} 
							setInfoPatient={this.setInfoPatient}
							setInfoDonor={this.setInfoDonor}
							dateHandleChange = {this.datePatHandleChange}
							autocompleteHandle={this.autocompleteHandle}
							getNextPatient={this.props.getPatientNumber}
							clearPatientSearch = {this.clearPatientSearch}/>
					:null}
					{/*!this.props.agenda ?
						this.state.show_patient_data ? 
							this.state.special_patient.map((d, i)=>(
								<div key={i} className="col-xs-12 col-sm-2">
									<div><span className="span-min">{d.Etiqueta}</span></div>
									<div className="col-xs-12" style={{padding:'0'}}>
										{Parser(d.html)}
									</div>
								</div>
							))
						:null
							:null*/}

					{!this.props.agenda ?
						<Toolbar {...this.props} state={this.state} onRef={ref => (this.tool = ref)} history={this.props.history}/>
					:null}
		    	</div>
	        	<div className="col-xs-3" style={{background:'#f2f4f6'}}>
	        		<AvatarPerson {...this.props} 
	        		validate={this.validateInput}
	        		onRef={ref => (this.avatar = ref)} 
	        		state={this.state}
	        		stats={this.state.stats}
	        		donor_number={this.state.donor_number}
	        		offer_id={this.state.offer_id}
	        		updateFingerprint={this.updateFingerprint}
	        		returnPhoto = {this.updatePhoto}
	        		don_hue_dig={this.state.don_hue_dig}
	        		handleChange={this.handleChange}
	        		selectFieldHandle = {this.selectFieldHandle}
	        		addPhoneToList={this.addPhoneToList} 
	        		removePhoneFromList={this.removePhoneFromList}
	        		phonesAdded = {this.state.phonesAdded}
	        		/>
	        	</div>
	        	
	        	
	        	
	        	<Notifications />
	        </div>
		);
	}
}

export default FormOffers;